import React, { createContext, ReactNode, useContext } from "react";

import { IChapterMediaLinkService } from "../types/services/chapter-media-link-service";

const ChapterMediaLinkServiceContext = createContext<IChapterMediaLinkService>(
  undefined as any,
);

interface ChapterMediaLinkServiceProviderProps {
  children: ReactNode;
  service: IChapterMediaLinkService;
}

function ChapterMediaLinkServiceProvider(
  props: ChapterMediaLinkServiceProviderProps,
) {
  const { children, service } = props;

  return (
    <ChapterMediaLinkServiceContext.Provider value={service}>
      {children}
    </ChapterMediaLinkServiceContext.Provider>
  );
}

function useChapterMediaLinkService() {
  return useContext(ChapterMediaLinkServiceContext);
}

export { ChapterMediaLinkServiceProvider, useChapterMediaLinkService };
